import './style.css'
const ErrorMessage = ({text})=>{
    return(
        <h3 className="error-msg">{text}</h3>
    )
}

export default ErrorMessage